<div class="liquidations-container">
  <!-- Loading Spinner -->
  <div *ngIf="isLoading()" class="flex justify-center items-center py-8">
    <mat-spinner diameter="40"></mat-spinner>
    <span class="ml-3 text-gray-600 dark:text-gray-400">Cargando liquidaciones...</span>
  </div>

  <!-- Smart Grid -->
  <div *ngIf="!isLoading()">
    <app-smart-grid
      [columnDefs]="liquidationsColumnDefs"
      [data]="liquidations()"
      [config]="liquidationsGridConfig"
      [loading]="isLoading()"
      [detailTemplate]="detailTemplate">
    </app-smart-grid>

    <!-- Row Expansion Template for Material Details -->
    <ng-template #detailTemplate let-row="row">
      <div class="flex-1 flex flex-col h-full overflow-hidden px-4 py-6 bg-gray-50 dark:bg-gray-900">
        <!-- Detail Grid Title -->
        <div class="mb-4">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
            Materiales de la Liquidación
          </h3>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            Detalle de cantidades por material
          </p>
        </div>

        <!-- Nested Smart Grid for Material Details -->
        <app-smart-grid
          [columnDefs]="detailColumnDefs"
          [data]="row.detail || []"
          [config]="detailGridConfig"
          [loading]="false">
        </app-smart-grid>
      </div>
    </ng-template>
  </div>
</div>
